module.exports = __webpack_public_path__ + "img/9788960172661.e8941e66.jpg";